<template>
    <div class="mobile">
        <div class="mobile-header">
            <!--<img src="https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/closePerson.png" class="closePerson"  @click="closeWin"   alt="">-->
            <!-- <img class="logo" style="margin-left: 0.5rem;" src="https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/mobile_login.png" alt /> -->
            <!-- <img class="logo"  style="margin-left: 0.5rem;" :src="this.$route.query.loginLogo" alt /> -->
            <!-- <a href="javascript:;" @click="gotoStudy" class="fr">已选课程</a> -->
            <!-- <a href="javascript:;" class="fr selected_he" @click="gotoStudy"> -->
             <!-- <img src="https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/select_hei.png" class="fr selected_he" alt=""  > -->

        <!-- </a> -->
              <div class="mobile-header-inner">
                <span class="logo" >
                    <img   :src="this.$route.query.indexLogo" alt />
                </span>
                <span class="selected_he" alt="" @click="gotoStudy">
                    <img src="https://static.yun.chinahrt.com/Appfiles/customer_examination1-vue/static/images/select_hei.png" width="80%" alt="">
                </span>
             </div>
        </div>
        <div class="mobile-tabs">
            <ul>
                <li v-for="list in fristLevelColumn" :key="list.id" :class="{ active: active == list.id }" @click="changeCategory(list.id,list.name)">{{ list.name }}</li>
            </ul>
        </div>
        <div class="mobile-classify" style="margin-top: .4rem;">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <van-cell v-for="item in list" :key="item.id">
                    <div class="list"  @click="goToGoodsDetails(item.id)" >
                        <div class="picture"><img  :src="item.goodsPic" alt /></div>
                        <h5>【视频】{{item.goodsName}}</h5>
                        <span class="classify fl">{{item.categoryName}}</span>
                        <span class="period fr">
                          <i class="icon"></i>{{item.testHours}}学时
                        </span>
                    </div>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
    import { List } from 'vant';
    import '../../js/baiducount.js'
    export default {
        data () {
            return {
                active: 0,
                fristLevelColumn:[{ id: 0, name: "推荐" }],
                list: [],
                loading: false,
                finished: false,
                page:1,
                pageSize:10
            }
        },
        components: {
            List
        },
        watch: {
            '$route'(to,from) {
                let categoryId = this.$route.query.categoryId;
                this.active=categoryId;
                this.list=[];
                this.loading=false;
                this.finished= false;
                this.page=1;
                this.onLoad();

            }
        },
       /* beforeRouteEnter (to, from, next) {
            to.meta.keepAlive = false;
            next();
        },
        beforeRouteLeave (to, from, next) {
            to.meta.keepAlive = false;
            next();
        },*/
        methods: {
            initFristLevelColumn:function(){
                this.$axiosPackag.getMessageByAxios("POST","/goodsCategory/listCategory",{pid:0},null,null, successCallResult =>{
                    if(successCallResult && successCallResult.count>0){
                        let categoryList =successCallResult.categoryList;
                        if(categoryList){
                            let array=[];
                            categoryList.forEach(function(item,index){
                                let columnItem={};
                                columnItem.id=item.id;
                                columnItem.name=item.name;
                                array.push(columnItem);
                            });
                            this.fristLevelColumn=this.fristLevelColumn.concat(array);
                        }
                    }
                },errorCall=>{
                });
            },
            changeCategory(categoryId,categoryName){
                if(categoryId!=0){
                    this.$router.push({ path: '/mobileCategory' ,query:{categoryId:categoryId,categoryName:categoryName}});
                }else{
                    this.$router.push({ path: '/mobileHome'});
                }
            },
            onLoad() {
                this.loading = true;
                console.info("开始加载了");
                try{
                    setTimeout(() => {
                        this.$axiosPackag.getMessageByAxios("GET","/web/goodsMobile/getGoodsList",{categoryId:this.active,page:this.page,pageSize:this.pageSize},null,null, successCallResult =>{
                            this.page++;
                            if(successCallResult && successCallResult.total>0){
                                let rows=successCallResult.rows;
                                if(rows && rows.length>0){
                                    for(let i=0 ;i<rows.length;i++){
                                        let columnItem={};
                                        columnItem.id=rows[i].id;
                                        columnItem.goodsPic=rows[i].pictureShowUrl;
                                        columnItem.goodsName=rows[i].goodsName;
                                        if(!this.$util.isBlackStr(rows[i].goodsDesc)){
                                            let textDesc=this.$util.html(rows[i].goodsDesc);
                                            textDesc=this.$util.filterHtmlTag(textDesc);
                                            if(!this.$util.isBlackStr(textDesc)){
                                                if(textDesc.length>30){
                                                    textDesc=textDesc.substr(0,30);
                                                }
                                                columnItem.goodsDesc=textDesc;
                                            }
                                        }
                                        columnItem.testHours=rows[i].testHours;
                                        columnItem.categoryName=this.$route.query.categoryName;
                                        this.list.push(columnItem);
                                    }
                                    if(this.list.length>=successCallResult.total){
                                        this.finished = true;
                                    }
                                }else{
                                    this.loading = false;
                                    this.finished = true;
                                }
                            }else{
                                this.loading = false;
                                this.finished = true;
                            }
                            this.loading = false;
                        },errorCall=>{
                            this.finished = true;
                            this.loading = false;
                        });

                    }, 100);
                }catch(e){
                    this.finished = true;
                }
            },
            goToGoodsDetails:function (goodsId) {
                this.$router.push({path: '/mobileCourseDetail' ,query:{id:goodsId}});
            },
            closeWin(){
                var browserName = navigator.appName;
                var browserVer = parseInt(navigator.appVersion);
                if(browserName == "Microsoft Internet Explorer"){
                    var ie7 = (document.all && !window.opera && window.XMLHttpRequest) ? true : false;
                    if (ie7){
                        //This method is required to close a window without any prompt for IE7 & greater versions.
                        window.open('','_parent','');
                        window.close();
                    }else{
                        //This method is required to close a window without any prompt for IE6
                        this.focus();
                        self.opener = this;
                        self.close();
                    }
                }else{
                    //For NON-IE Browsers except Firefox which doesnt support Auto Close
                    try{
                        this.focus();
                        self.opener = this;
                        self.close();
                    }catch(e){
                    }
                    try{
                        window.open('','_self','');
                        window.close();
                    }catch(e){

                    }
                    try{
                        window.open(location, '_self').close();
                    }catch(e){

                    }
                }
                //移动端的
                try{
                    var u = navigator.userAgent;
                    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                    if(isiOS){
                         //公众号关闭
                         WeixinJSBridge.call('closeWindow');
                    }else if(isAndroid){
                         //公众号关闭
                         document.addEventListener('WeixinJSBridgeReady', function(){ WeixinJSBridge.call('closeWindow'); }, false)
                    }
                }catch(e){

                }

            },
            gotoStudy(){
                this.$router.push({ path: '/mobileStudy'});
            }
        },
        created: function () {

        },
        mounted () {
            let categoryId = this.$route.query.categoryId;
            this.active=categoryId;
            this.initFristLevelColumn();
            setTimeout(function() {
                let avtiveLeft = document.querySelector('.mobile-tabs ul li.active').offsetLeft
                let tabsWidth = document.querySelector('.mobile-tabs').offsetWidth / 2
                let avtiveWidth = $('.mobile-tabs ul li.active').outerWidth(true) - $('.mobile-tabs ul li.active').outerWidth()
                if (avtiveLeft >= tabsWidth) {
                    document.querySelector('.mobile-tabs').scrollLeft = avtiveLeft - tabsWidth + avtiveWidth
                }
            }, 500)
        },
        computed: {

        }
    }
</script>

<style scoped>
    .closePerson {
        position: absolute;
        height: 0.4rem;
        height: 0.4rem;
        left: 0.4rem;
        top: 0.4rem;
    }
      .mobile-header a{
     overflow: hidden;
     display: inline-block;
     display: flex;
     flex-direction: column;
     align-items: center;
     width: auto;
  }
  .mobile-header a span{
      display:flex;
  }
  /* .selected_he{
      width: .72rem;
      height: .666667rem
  } */
    .mobile-header{display: flex;align-items: center;}
</style>


// WEBPACK FOOTER //
// MobileCategory.vue?396a358c